import React from "react"
import {
    CheckboxOptions,
    RuleType,
} from "layouts/charging-rules/interface/Rules.ts"
import { useChargingRulesContext } from "layouts/charging-rules/context/useChargingRulesContext.ts"
import { OreveChipButton } from "components/OreveChip.tsx"
import { Box } from "@mui/material"

interface CharginRuleCheckboxProps {
    ruleOptions: CheckboxOptions
    language: string
    ruleType: RuleType
    onReset?: () => void
}

export const ChargingRulesCheckboxComponent: React.FC<
    CharginRuleCheckboxProps
> = ({ ruleOptions: ruleOptions, language, ruleType }) => {

    const { dispatch } = useChargingRulesContext()

    const handleCheckboxChange = (key: keyof CheckboxOptions) => {
        dispatch({
            type:"toggleOption",
            ruleType: ruleType,
            option: key
        })
    }

    // Selection state is now derived globally from reducer state (no local setters)

    const translateLabel = (key: keyof CheckboxOptions) => {
        if (ruleType === RuleType.DOWBlocked) {
            const dayTranslations = {
                fr: {
                    monday: "Lundi",
                    tuesday: "Mardi",
                    wednesday: "Mercredi",
                    thursday: "Jeudi",
                    friday: "Vendredi",
                    saturday: "Samedi",
                    sunday: "Dimanche",
                },
                en: {
                    monday: "Monday",
                    tuesday: "Tuesday",
                    wednesday: "Wednesday",
                    thursday: "Thursday",
                    friday: "Friday",
                    saturday: "Saturday",
                    sunday: "Sunday",
                },
            }
            const translations =
                dayTranslations[language as "fr" | "en"] || dayTranslations.en
            return translations[key as keyof typeof translations] || key
        }
        return key
    }
    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: "10px", width: '100%' }}>
            {Object.keys(ruleOptions).map((key, index) => (
                <OreveChipButton
                    key={index}
                    label={translateLabel(key as keyof CheckboxOptions).toString()}
                    onClick={() => handleCheckboxChange(key as keyof CheckboxOptions)}
                    isDefault={ruleOptions[key as keyof CheckboxOptions]}
                    dataCy={`nav-charging-rules__${ruleType}`}
                />
            ))}

        </Box>
    )
}
